'use strict';

import './Buffer.js';
